export const GENERATION = '6';
export const OT_DATE = '3월 4일';

//* 6기: ZOOM 활용 X, 추가 모집/구글폼 부분 추후 수정
export const ADDITIONAL_RECRUITMENT_FE_DEVELOPER = '(2.18~2.25)';
export const ZOOM_MEETING_ID = '524 202 5058';
export const ZOOM_MEETING_PASSWORD = 'Zjt52U';
export const ZOOM_MEETING_URL = 'https://discord.gg/dT7XGvAH';
export const PASS_CHECK_FORM = 'https://forms.gle/ubURYsFWdoaxr5SKA';
export const MEETING_CHECK_FORM = 'https://forms.gle/pnWSPdHrKrL4fgrXA';

//* 6기 정보 반영 완료
export const WEP_OPEN_TIME = '02/01/2025 00:00';
export const RECRUIT_OPEN_TIME = '02/25/2026 09:00';
export const RECRUIT_CLOSE_TIME = '02/26/2026 23:59';
export const FIRST_RESULT_OPEN_TIME = '02/17/2026 13:00';
export const FINAL_RESULT_OPEN_TIME = '02/24/2026 18:00';
export const SERVER_CLOSE_TIME = '03/04/2026 00:00';

export const isResultActive =
  new Date() >= new Date(FIRST_RESULT_OPEN_TIME) &&
  new Date() <= new Date(SERVER_CLOSE_TIME);

export const isRecruitmentActive =
  new Date() >= new Date(RECRUIT_OPEN_TIME) &&
  new Date() <= new Date(RECRUIT_CLOSE_TIME);
